import {post} from "../../../DAL/data-provider";

export const checkIfPluginIsForFree = async (cid:number,itemCode:string) => {
    return post('/api/freeplugins/is-plugin-for-free',
        {  cid:cid,
            itemCode:itemCode});
};

